import axios from 'axios';


export const getShiftWorkbenchSubStuff=(where:string) =>{
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/workbench-sub-stuff?where=`+where,
  );
}
export const AddShiftWorkbenchSubStuff=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/workbench-sub-stuff/create`,
    obj,
    { headers }
  );
}

export const EditShiftWorkbenchSubStuff=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/workbench-sub-stuff/edit`,
    obj,
    { headers }
  );
}

export const DeleteShiftWorkbenchSubStuff=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`shift-workbench/workbench-sub-stuff/delete`,
    obj,
    { headers }
  );
}